module.exports = __webpack_public_path__ + "img/psl87q31rb1rl3wp9bze5l95gyn7k5rf5qc04b4f622-a3e0-4949-9f77-7b3b4e3dec56.826779a4.png";